import React, { Component } from "react";
import Modal from "react-modal";
import { connect } from "react-redux";
import {
  selectMemberInfo,
  hideFreezeModal
} from "../../../state/ducks/member/index";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    transform: "translate(-50%, -50%)",
    border: "none",
    padding: "0",
    background: "none"
  }
};

Modal.setAppElement("#app");

class FreezeDetail extends Component {
  hideModal = () => {
    this.props.hideFreezeModal();
  };

  render() {
    const { memberInfo } = this.props;
    return (
      <Modal
        isOpen={memberInfo?.freezeIsOpen}
        onRequestClose={this.closeModal}
        style={{
          overlay: {
            position: 'fixed',
            inset: "0% 0% 0% 0%",
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.4)'
          },
          content: {
            position: 'fixed',
            width: '100%',
            height: '100%',
            overflow: 'hidden',
            top: 0,
            left: 0,
            border: '0px',
            backgroundColor: 'transparent' /* Black w/ opacity */

          }
        }}
      >
        
 <div className="t-modalAreaFreezeDetail" id="modalFreezeDetail">
  {/* Bu kısım animasyon için Hareket eden kısım. */}
  <div className="t-modalContentFreezeDetail" id="id-modalTipi" style={(window.innerWidth<=900)?{width:"89%"}: {width:"60%"}}>
    <div
      className="t-modalFreezeDetail"
      id="id-modalGenel"
      style={{ backgroundColor: "rgb(255, 255, 255)" }}
    >
      <div className="container-fluid">
        {/* Header */}
        <div className="row t-modalHeaderFreezeDetail">
          <div
            className="col"
            id="id-modalHeader"
            style={{ color: "rgb(153, 153, 153)" }}
          >
             Taksit Ertelenen Aylar
          </div>
          <div className="col-auto t-cursorPointer" onClick={() => this.hideModal()}>
            <i
              className="t-icon-cross"
              id="id-modalHeaderIcon"
              style={{ color: "rgb(153, 153, 153)" }}
            />
          </div>
        </div>
        {/* Body */}
        <div className="row t-modalBodyFreezeDetail">
          <div
            className="col-12"
            id="id-modalBody"
            style={{ color: "rgb(153, 153, 153)" }}
          >
            <table className="table table-sm t-tablo">
              <thead>
                <tr>
                  <th scope="col">Taksit Ertelenen Aylar</th>
                </tr>
              </thead>
              <tbody>
              {memberInfo?.freezeDetail &&
                    memberInfo.freezeDetail.map(item => {
                      return (
                        <tr key={item.id}>
                          <td className="text-center">{item.dondurmaTarihi}</td>
                        </tr>
                      );
                    })}
             
              </tbody>
            </table>
          </div>
        </div>
        {/* footer*/}
        <div className="row t-modalFooterFreezeDetail">
          <div
            className="col-12"
            id="id-modalFooter"
            style={{ color: "rgb(153, 153, 153)" }}
          />
        </div>
      </div>
    </div>
  </div>
</div>

      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    memberInfo: selectMemberInfo(state)
  };
};

const mapDispatchToProps = dispatch => ({
  hideFreezeModal: () => dispatch(hideFreezeModal())
});

export default connect(mapStateToProps, mapDispatchToProps)(FreezeDetail);
